import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH CHANNELS_SYSTEM TO EDIT ********************
export const fetchChannelsSystem = (channelId, { systemName }) => async (
	dispatch
) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_CHANNELS_SYSTEM_LOADING,
			payload: true
		});

		const { data } = await services.get(
			`channel/${channelId}/systemFields?system=${systemName}`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_CHANNELS_SYSTEM_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_CHANNELS_SYSTEM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
